import { LOCAL_STORAGE_KEY_KEEP_PLAYING, LOCAL_STORAGE_KEY_PROGRESS } from "../store/params.js";

export const handlePlayloop = (playorstop) => {
  if (playorstop === "play") {
    localStorage.setItem(LOCAL_STORAGE_KEY_KEEP_PLAYING, 1);
  } else {
    localStorage.setItem(LOCAL_STORAGE_KEY_KEEP_PLAYING, 0);
  }
}

export const getStorage = () => {
  if (localStorage.getItem(LOCAL_STORAGE_KEY_PROGRESS) !== null) {
    const stringInStorage = localStorage.getItem(LOCAL_STORAGE_KEY_PROGRESS);
    return JSON.parse(stringInStorage);
  } else {
    return { "empty": [] };
  }
}

export const getReaded = () => {
  const storageData = getStorage();
  return storageData;
}

export const getLSDefaultPlaying = () => {
  let autoplay = null;
  if (localStorage.getItem(LOCAL_STORAGE_KEY_KEEP_PLAYING) === null) {
    localStorage.setItem(LOCAL_STORAGE_KEY_KEEP_PLAYING, 0);
    autoplay = 0;
  } else {
    autoplay = parseInt(localStorage.getItem(LOCAL_STORAGE_KEY_KEEP_PLAYING));
  }
  return autoplay;
}

export const getIndexLastSongPlayed = (namePlaylist) => {
  let numberplayed = 0;
  if (localStorage.getItem(LOCAL_STORAGE_KEY_PROGRESS) !== null) {
    if (typeof JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_PROGRESS)) === "object") {
      const stringInStorage = localStorage.getItem(LOCAL_STORAGE_KEY_PROGRESS);
      const objectInStorage = JSON.parse(stringInStorage);
      const playlistValue = objectInStorage[namePlaylist];
      if (Array.isArray(playlistValue)) {
        numberplayed = playlistValue.filter(song => !!song).length;
      }
    }
  }
  return numberplayed;
}


export const cleanStorageByPlaylist = (playlist) => {
  const storedProgress = getStorage();
  // Vérifier si la playlist existe dans storedProgress
  if (storedProgress[playlist]) {
    const playlistCleaned = Array(storedProgress[playlist].length).fill(false);
    storedProgress[playlist] = playlistCleaned;
    localStorage.setItem(LOCAL_STORAGE_KEY_PROGRESS, JSON.stringify(storedProgress));
  } else {
    console.error(`La clé de playlist '${playlist}' n'existe pas dans le stockage.`);
  }
}

export const updateStorage = (playlists) => {
  const storedProgress = getStorage();

  let needsUpdate = false;
  playlists.forEach(playlist => {
    if (!storedProgress[playlist.name] || storedProgress[playlist.name].length !== playlist.songs.length) {
      needsUpdate = true;
      // Initialiser la clé manquante avec un tableau de booléens
      storedProgress[playlist.name] = Array(playlist.songs.length).fill(false);
    }
  });

  if (needsUpdate) {
    localStorage.setItem(LOCAL_STORAGE_KEY_PROGRESS, JSON.stringify(storedProgress));
  }
}

export const cleanStorage = (playlists) => {
  updateStorage(playlists);
}